import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { products } from '../../data/products';
// Order: SC-A, SC-B x3, SC-C
const orderedProducts = [...products.filter(p => p.series === 'sca'), ...products.filter(p => p.series === 'scb'), ...products.filter(p => p.series === 'scc')];
type RowDef = {
  label: string;
  render: (p: (typeof orderedProducts)[0]) => React.ReactNode;
  highlight?: boolean;
};
export function ProductComparison() {
  const rows: RowDef[] = [{
    label: 'Serija',
    render: p => <span className="text-xs font-black uppercase tracking-wider text-brand-yellow" data-id="element-383">
          {p.model}
        </span>
  }, {
    label: 'Cena (bez PDV)',
    highlight: true,
    render: p => <span className="font-bold text-brand-yellow" data-id="element-384">
          €{p.price.toLocaleString()}
        </span>
  }, {
    label: 'Namena',
    render: p => {
      if (p.series === 'sca') return 'Stepenice — heavy duty';
      if (p.series === 'scb') return 'Stepenice — standardno';
      return 'Ravne površine';
    }
  }, {
    label: 'Nosivost',
    render: p => p.specs.capacity
  }, {
    label: 'Motor',
    render: p => p.specs.motor
  }, {
    label: 'Baterija',
    render: p => p.specs.battery
  }, {
    label: 'Punjenje',
    render: p => p.specs.chargingTime
  }, {
    label: 'Električna kočnica',
    render: p => p.series !== 'scc' ? <CheckIcon className="w-5 h-5 text-brand-yellow mx-auto" data-id="element-385" /> : <span className="text-gray-600 text-xs" data-id="element-386">Nije primenjivo</span>
  }, {
    label: 'Regulacija brzine',
    render: p => p.series !== 'scc' ? <span className="text-gray-300 text-xs" data-id="element-387">Beskrajna</span> : <span className="text-gray-600 text-xs" data-id="element-388">Nije primenjivo</span>
  }, {
    label: 'Zaštitni neklizajući sloj',
    highlight: true,
    render: p => {
      if (p.series === 'sca') return <span className="text-gray-600 text-xs" data-id="element-389">Nije primenjivo</span>;
      if (p.id === 'standard') return <span className="text-gray-600 text-xs" data-id="element-390">Nema</span>;
      if (p.series === 'scc') return <span className="text-gray-600 text-xs" data-id="element-391">Nije primenjivo</span>;
      return <CheckIcon className="w-5 h-5 text-brand-yellow mx-auto" data-id="element-392" />;
    }
  }, {
    label: 'Zaštitna boja otporna na habanje',
    highlight: true,
    render: p => {
      if (p.id === 'raptor') return <CheckIcon className="w-5 h-5 text-brand-yellow mx-auto" data-id="element-393" />;
      if (p.series === 'scc') return <span className="text-gray-600 text-xs" data-id="element-394">Nije primenjivo</span>;
      return <span className="text-gray-600 text-xs" data-id="element-395">Nema</span>;
    }
  }, {
    label: 'Pneumatski točkovi',
    highlight: true,
    render: p => p.series === 'scc' ? <CheckIcon className="w-5 h-5 text-brand-yellow mx-auto" data-id="element-396" /> : <span className="text-gray-600 text-xs" data-id="element-397">Nije primenjivo</span>
  }, {
    label: 'Dimenzije',
    render: p => <span className="text-xs" data-id="element-398">{p.specs.size}</span>
  }, {
    label: 'Težina',
    render: p => p.specs.weight
  }, {
    label: 'Rok isporuke',
    render: p => <span className="text-xs" data-id="element-399">{p.specs.leadTime}</span>
  }];
  return <div className="overflow-x-auto" data-id="element-400">
      <table className="w-full border-2 border-dark-border rounded-industrial min-w-[700px]" data-id="element-401">
        <thead data-id="element-402">
          <tr className="bg-dark-surface" data-id="element-403">
            <th className="px-4 py-4 text-left text-xs font-bold text-gray-400 uppercase tracking-wider border-b-2 border-dark-border w-44" data-id="element-404">
              Specifikacija
            </th>
            {orderedProducts.map(product => <th key={product.id} className={`px-4 py-4 text-center text-xs font-bold text-white uppercase tracking-wider border-b-2 border-dark-border border-l-2 ${product.series === 'sca' ? 'bg-brand-yellow/5' : product.series === 'scc' ? 'bg-blue-900/10' : ''}`} data-id="element-405">
                {product.badge && <div className="text-[9px] font-black text-brand-yellow/70 tracking-widest mb-1 normal-case" data-id="element-406">
                    {product.badge}
                  </div>}
                <div className="text-white text-xs" data-id="element-407">
                  {product.name.replace('D-TECH ', '')}
                </div>
                <div className="text-[10px] text-brand-yellow/60 font-semibold normal-case mt-0.5" data-id="element-408">
                  {product.model}
                </div>
                <div className="text-base font-black text-brand-yellow mt-1" data-id="element-409">
                  €{product.price.toLocaleString()}
                </div>
              </th>)}
          </tr>
        </thead>
        <tbody data-id="element-410">
          {rows.map((row, idx) => <tr key={row.label} className={`${idx % 2 === 0 ? 'bg-dark-bg' : 'bg-dark-surface'}`} data-id="element-411">
              <td className="px-4 py-3 text-xs font-semibold text-gray-400 border-b border-dark-border" data-id="element-412">
                {row.label}
                {row.highlight && <span className="ml-1.5 text-[9px] font-black text-brand-yellow/60 bg-brand-yellow/10 border border-brand-yellow/20 px-1 py-0.5 rounded" data-id="element-413">
                    RAZLIKA
                  </span>}
              </td>
              {orderedProducts.map(product => <td key={product.id} className="px-4 py-3 text-xs text-center text-gray-300 border-b border-dark-border border-l-2" data-id="element-414">
                  {row.render(product)}
                </td>)}
            </tr>)}
        </tbody>
      </table>
      <p className="mt-4 text-xs text-gray-500 text-right px-1" data-id="element-415">
        Cene bez PDV-a. Rok isporuke ~2 meseca od potvrde porudžbine.
      </p>
    </div>;
}